import { Col } from 'reactstrap'
import moment from 'moment'
import { ReactComponent as DownloadIcon } from 'assets/images/icons/download.svg'

function InvoicesList(props) {
  const { invoices, stripe_customer } = props
  return (
    <>
      {/* Web */}
      <div className='d-none d-sm-flex flex-column w-100'>
        <div className='d-flex flex-wrap invoice justify-content-between w-100 mb-3'>
          <Col className='px-0 invoice-heading font-weight-600 text-secondary'>Date</Col>
          <Col className='px-0 invoice-heading font-weight-600 text-secondary '>Total</Col>
          {!window.navigator.userAgent.toLowerCase().includes('zoom') && (
            <Col className='px-0 col-auto invoice-heading font-weight-600 text-secondary' style={{ width: 115 }}>
              Download PDF
            </Col>
          )}
        </div>
        {invoices.map((invoice, index) => (
          <div className='d-flex flex-wrap invoice justify-content-between w-100 mb-4' key={invoice.id}>
            <Col className='px-0 invoice-data'>{moment.utc(invoice.created).local().format('ll')}</Col>
            <Col className='px-0 invoice-data'>
              ${invoice.total}
              {index === 0 && stripe_customer.balance < 0 ? <span className='small ml-1'>(credit: ${Math.abs(stripe_customer.balance / 100).toFixed(2)})</span> : ''}
            </Col>
            {!window.navigator.userAgent.toLowerCase().includes('zoom') && (
              <Col className='px-0 col-auto invoice-data' style={{ width: 115 }}>
                {invoice.invoice_pdf && (
                  <a href={invoice.invoice_pdf} target='_blank' rel='noopener noreferrer'>
                    <DownloadIcon /> Download
                  </a>
                )}
              </Col>
            )}
          </div>
        ))}
      </div>
      {/* Mobile */}
      <div className='d-flex flex-column w-100 d-sm-none px-3'>
        {invoices.map((invoice, index) => (
          <div key={index} className='d-flex flex-wrap invoice mobile-cards'>
            <Col>
              <div className='mb-2'>{moment.utc(invoice.created).local().format('ll')}</div>
              <div className='font-weight-600'>
                ${invoice.total} {index === 0 && stripe_customer.balance < 0 ? <span className='small ml-1'>(credit: ${Math.abs(stripe_customer.balance / 100).toFixed(2)})</span> : ''}
              </div>
            </Col>
            {!window.navigator.userAgent.toLowerCase().includes('zoom') && (
              <Col className='col-auto' style={{ width: 115 }}>
                {invoice.invoice_pdf && (
                  <a href={invoice.invoice_pdf} target='_blank' rel='noopener noreferrer'>
                    <DownloadIcon /> Download
                  </a>
                )}
              </Col>
            )}
          </div>
        ))}
      </div>
    </>
  )
}

export default InvoicesList
